import { headerViewApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const HEADER_VIEW_ACTION_TYPE = createNamedActions(
  // LOAN_APPLICATION_ACTION_NAME_PREFIX is used for Redux Middleware in Loan Editor
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/headerView`,
  {
    GET_LOAN_APPLICATION_HEADER_VIEW: 'GET_LOAN_APPLICATION_HEADER_VIEW',
    UPDATE_AUS_RELATED_DATA: 'UPDATE_AUS_RELATED_DATA',
    GET_LOAN_APPLICATION_HEADER_VIEW_PENDING_STATUS:
      'GET_LOAN_APPLICATION_HEADER_VIEW_PENDING_STATUS',
    GET_LOAN_APPLICATION_HEADER_VIEW_REJECTED_STATUS:
      'GET_LOAN_APPLICATION_HEADER_VIEW_REJECTED_STATUS',
  },
);

export const getLoanApplicationHeaderViewAction = params =>
  catchAsyncActionError(({ applicationId, includePendingChanges = true }) => async dispatch => {
    const { data } = await headerViewApi.getLoanApplicationHeaderView({
      applicationId,
      includePendingChanges,
    });

    return dispatch({
      type: HEADER_VIEW_ACTION_TYPE.GET_LOAN_APPLICATION_HEADER_VIEW,
      payload: data,
    });
  })({
    ...params,
    rejectedAction: () => ({
      type: HEADER_VIEW_ACTION_TYPE.GET_LOAN_APPLICATION_HEADER_VIEW_REJECTED_STATUS,
    }),
    pendingAction: () => ({
      type: HEADER_VIEW_ACTION_TYPE.GET_LOAN_APPLICATION_HEADER_VIEW_PENDING_STATUS,
    }),
  });

export const updateAusRelatedDataAction = data => ({
  type: HEADER_VIEW_ACTION_TYPE.UPDATE_AUS_RELATED_DATA,
  payload: data,
});
